import React from 'react';
import { Outlet, NavLink, Link, Navigate, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Calendar, Users, Wine, ListChecks, Settings, Inbox, Mail, LogOut, ExternalLink, Loader2, Newspaper, Globe, FolderOpen } from 'lucide-react';
import Logo from '../../components/Logo';
import { useAdminAuth } from '../../lib/AdminAuthContext';

const NAV = [
  { to: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/experiencias', icon: Calendar, label: 'Experiencias' },
  { to: '/admin/noticias', icon: Newspaper, label: 'Noticias' },
  { to: '/admin/minisites', icon: Globe, label: 'Minisites' },
  { to: '/admin/media', icon: FolderOpen, label: 'Media' },
  { to: '/admin/equipo', icon: Users, label: 'Equipo' },
  { to: '/admin/colaboradores', icon: Wine, label: 'Colaboradores' },
  { to: '/admin/ofrecemos', icon: ListChecks, label: 'Qué ofrecemos' },
  { to: '/admin/inscripciones', icon: Inbox, label: 'Inscripciones' },
  { to: '/admin/contactos', icon: Mail, label: 'Contactos' },
  { to: '/admin/newsletter', icon: Mail, label: 'Newsletter' },
  { to: '/admin/ajustes', icon: Settings, label: 'Ajustes del sitio' },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen bg-[#0d0d0e] flex items-center justify-center text-[#c9a063]"><Loader2 size={28} className="animate-spin" /></div>;
  if (!user) return <Navigate to="/admin" replace />;

  const doLogout = () => { logout(); navigate('/admin'); };

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white flex">
      <aside className="w-64 bg-[#0d0d0e] border-r border-white/5 flex flex-col flex-shrink-0">
        <div className="p-6 border-b border-white/5"><Logo size="sm" /></div>
        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? 'bg-[#c9a063]/10 text-[#c9a063] border-l-2 border-[#c9a063]' : 'text-white/70 hover:bg-white/5 hover:text-white border-l-2 border-transparent'}`}>
              <n.icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5 space-y-2">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-xs text-white/50 hover:text-[#c9a063] transition-colors"><ExternalLink size={13} /> Ver web pública</a>
          <div className="text-xs text-white/40 px-3">{user.email}</div>
          <button onClick={doLogout} className="flex items-center gap-2 px-3 py-2 text-xs text-white/70 hover:text-red-400 transition-colors w-full"><LogOut size={13} /> Cerrar sesión</button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
